import React from 'react';
import { FaFacebookF, FaInstagram, FaTiktok, FaYoutube } from 'react-icons/fa6';
import type { IconType } from 'react-icons';
interface SocialLink {
  label: string;
  href: string;
  icon: IconType;
}
const SOCIALS: SocialLink[] = [{
  label: 'Instagram',
  href: 'https://www.instagram.com/vivomedia.uy?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==',
  icon: FaInstagram
}, {
  label: 'YouTube',
  href: '#',
  icon: FaYoutube
}, {
  label: 'Facebook',
  href: '#',
  icon: FaFacebookF
}, {
  label: 'TikTok',
  href: '#',
  icon: FaTiktok
}];
export function Footer() {
  return <footer className="w-full border-t-2 border-vm-electric bg-black" data-id="element-95" data-mp="3lelzi2xtwhm3">
      <div className="mx-auto max-w-7xl px-6 py-8 lg:px-10" data-id="element-96" data-mp="3lggfd2u8tjjb">
        <div className="flex flex-col gap-6 border-t border-white/10 pt-8 sm:flex-row sm:items-center sm:justify-between" data-id="element-97" data-mp="3qc40961ozqj0">
          <p className="text-sm font-light text-vm-muted" data-id="element-98" data-mp="29xvqkc20tbos">
            © 2026 Vivo Media. Todos los derechos reservados.
          </p>

          <div className="flex items-center gap-4 sm:justify-end" data-id="element-99" data-mp="3l9ac9f9lwy2u">
            {SOCIALS.map(social => {
            const Icon = social.icon;
            return <a key={social.label} href={social.href} target={social.href === '#' ? undefined : '_blank'} rel={social.href === '#' ? undefined : 'noopener noreferrer'} aria-label={social.label} className="flex h-10 w-10 items-center justify-center rounded-2xl border border-vm-muted/50 text-vm-muted transition-colors hover:border-vm-electric hover:text-white" data-id="element-100" data-mp="3gcjvsqtw40gw">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-101" data-mp="huwiqy10k36t" />
                </a>;
          })}
          </div>
        </div>
      </div>
    </footer>;
}